import {LoginCookieKey} from "./constant"
import Cookies from "js-cookie";

export let Predefs;

export function GetPredefs(successCallback) {
    $.ajax(window.location.protocol + "//" + window.location.host + '/predefs', {
        method: 'GET',
        headers: {
            "X-User-Token": Cookies.get(LoginCookieKey)
        },
        success: function (data) {
            Predefs = data;

            if (successCallback) {
                successCallback(data);
            }
        }
    })
}

export function T(key, params) {
    let translatedString = Predefs.translations[key];

    if (params == null) {
        return translatedString
    }

    Object.entries(params).forEach(entry => {
        const [key, value] = entry;
        translatedString = translatedString.replace("{{"+key+"}}", value);
    })

    return translatedString
}

export function getTimeAgo(unixTimestamp, lang = "en") {
    const eventTime = new Date(unixTimestamp * 1000);
    const now = new Date();
    const diff = now - eventTime;
    const minutes = Math.floor(diff / (1000 * 60));
    const hours = Math.floor(minutes / 60);

    function polishMinutes(minutes) {
        if (minutes === 1) return "1 minutę temu";
        const lastDigit = minutes % 10;
        const lastTwoDigits = minutes % 100;
        if (lastTwoDigits >= 12 && lastTwoDigits <= 14) return `${minutes} minut temu`; // 12, 13, 14
        if (lastDigit === 2 || lastDigit === 3 || lastDigit === 4) return `${minutes} minuty temu`; // np. 2, 3, 4
        return `${minutes} minut temu`;
    }

    function polishHours(hours) {
        if (hours === 1) return "1 godzinę temu";
        const lastDigit = hours % 10;
        const lastTwoDigits = hours % 100;
        if (lastTwoDigits >= 12 && lastTwoDigits <= 14) return `${hours} godzin temu`; // 12, 13, 14
        if (lastDigit === 2 || lastDigit === 3 || lastDigit === 4) return `${hours} godziny temu`; // np. 2, 3, 4
        return `${hours} godzin temu`;
    }

    switch (lang) {
        case "pl":
            if (minutes === 0) {
                return "Teraz";
            } else if (minutes < 60) {
                return polishMinutes(minutes);
            } else {
                return polishHours(hours);
            }
        case "es":
            if (minutes === 0) {
                return "Ahora";
            } else if (minutes === 1) {
                return "1 minuto atrás";
            } else if (minutes < 60) {
                return `${minutes} minutos atrás`;
            } else if (hours === 1) {
                return "1 hora atrás";
            } else {
                return `${hours} horas atrás`;
            }
        default:
            if (minutes === 0) {
                return "Now";
            } else if (minutes === 1) {
                return "1 minute ago";
            } else if (minutes < 60) {
                return `${minutes} minutes ago`;
            } else if (hours === 1) {
                return "1 hour ago";
            } else {
                return `${hours} hours ago`;
            }
    }
}

export function getTimeUntil(unixTimestamp, notificationTimestamp, lang = "en") {
    const eventTime = new Date(unixTimestamp * 1000);
    const now = new Date(notificationTimestamp * 1000);
    const diff = eventTime - now;

    const minutes = Math.floor(diff / (1000 * 60));
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    function polishMinutes(minutes) {
        if (minutes === 1) return "za 1 minutę";
        const lastDigit = minutes % 10;
        const lastTwoDigits = minutes % 100;
        if (lastTwoDigits >= 12 && lastTwoDigits <= 14) return `za ${minutes} minut`;
        if (lastDigit === 2 || lastDigit === 3 || lastDigit === 4) return `za ${minutes} minuty`;
        return `za ${minutes} minut`;
    }

    function polishHours(hours) {
        if (hours === 1) return "za 1 godzinę";
        const lastDigit = hours % 10;
        const lastTwoDigits = hours % 100;
        if (lastTwoDigits >= 12 && lastTwoDigits <= 14) return `za ${hours} godzin`;
        if (lastDigit === 2 || lastDigit === 3 || lastDigit === 4) return `za ${hours} godziny`;
        return `za ${hours} godzin`;
    }

    function polishDays(days) {
        if (days === 1) return "jutro";
        if (days === 2) return "za 2 dni";
        return `za ${days} dni`;
    }

    switch (lang) {
        case "pl":
            if (days > 0) return polishDays(days);
            if (hours > 0) return polishHours(hours);
            return polishMinutes(minutes);
        case "es":
            if (days > 1) return `en ${days} días`;
            if (days === 1) return "mañana";
            if (hours > 0) return `en ${hours} horas`;
            return `en ${minutes} minutos`;
        default:
            if (days > 1) return `in ${days} days`;
            if (days === 1) return "tomorrow";
            if (hours > 0) return `in ${hours} hours`;
            return `in ${minutes} minutes`;
    }
}